<template>
  <b-form @submit.prevent="openModalConfirm">
    <div class="form-parameter-wrapper">
      <b-form-group label-cols-sm="12" label-cols-lg="3" label="Top Up Kas Virtual Kelas 1" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group prepend="Rp">
              <b-form-input v-model="disbursementInput.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_SATU" name="plafondKasVirtualKelas1"
                required></b-form-input>
            </b-input-group>
            <span class="smallText text-muted">Nominal alokasi kas virtual untuk Kelas 1, disesuaikan setiap paginya.</span>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-cols-sm="12" label-cols-lg="3" label="Top Up Kas Virtual Kelas 2" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group prepend="Rp">
              <b-form-input v-model="disbursementInput.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_DUA" name="plafondKasVirtualKelas2"
                required></b-form-input>
            </b-input-group>
            <span class="smallText text-muted">Nominal alokasi kas virtual untuk Kelas 2, disesuaikan setiap paginya.</span>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-cols-sm="12" label-cols-lg="3" label="Top Up Kas Virtual Kelas 3" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group prepend="Rp">
              <b-form-input v-model="disbursementInput.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_TIGA" name="plafondKasVirtualKelas3"
                required></b-form-input>
            </b-input-group>
            <span class="smallText text-muted">Nominal alokasi kas virtual untuk Kelas 3, disesuaikan setiap paginya.</span>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-cols-sm="12" label-cols-lg="3" label="Notifikasi Disbursement KU" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group prepend="Rp">
              <b-form-input v-model="disbursementInput.NOTIF_DISBURSE_KU_MIN" name="minNotifDisbursementKu"
                required></b-form-input>
            </b-input-group>
            <span class="smallText text-muted">Minimum disbursement yang akan mengirimkan notifikasi ke KU cabang</span>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-cols-sm="12" label-cols-lg="3" label="Notifikasi Disbursement KC" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group prepend="Rp">
              <b-form-input v-model="disbursementInput.NOTIF_DISBURSE_KC_MIN" name="minNotifDisbursementKc"
                required></b-form-input>
            </b-input-group>
            <span class="smallText text-muted">Minimum disbursement yang akan mengirimkan notifikasi ke KC cabang</span>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-cols-sm="12" label-cols-lg="3" label="Notifikasi Disbursement AM" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group prepend="Rp">
              <b-form-input v-model="disbursementInput.NOTIF_DISBURSE_KCS_MIN" name="minNotifDisbursementKcs"
                required></b-form-input>
            </b-input-group>
            <span class="smallText text-muted">Minimum disbursement yang akan mengirimkan notifikasi ke AM
              cabang</span>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-cols-sm="12" label-cols-lg="3" label="Notifikasi Disbursement FINANCE" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group prepend="Rp">
              <b-form-input v-model="disbursementInput.NOTIF_DISBURSE_FINANCE_MIN" name="minNotifDisbursementFinance"
                required></b-form-input>
            </b-input-group>
            <span class="smallText text-muted">Minimum disbursement yang akan mengirimkan notifikasi ke Finance</span>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-cols-sm="12" label-cols-lg="3" label="Maksimum Pemberian Dana Tunai Kasus T+1" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group prepend="Rp">
              <b-form-input v-model="disbursementInput.MAX_PENCAIRAN_DISBURSE_DITANGGUHKAN" name="maxPencairanDisbursementDitangguhkan"
                required></b-form-input>
            </b-input-group>
            <span class="smallText text-muted">Nominal dana tertinggi yang bisa diberikan kepada nasabah yang disbursementnya terkendala kasus T+1</span>
          </b-col>
        </b-row>
      </b-form-group>
    </div>
    <div class="form-wrapper-btn submit-btn-wrapper">
      <b-button type="submit" name="parameterUpdateBtn" variant="pgiBtn">Update</b-button>
    </div>
    <ModalConfirm id="modal-edit-disbursement" title="Confirm Edit Parameter Disbursement" :isSubmitting="isSubmitting"
      desc="Apakah anda yakin untuk mengubah parameter disbursement ini?" @submit="onSubmit" />
  </b-form>
</template>

<script>
export default {
  name: 'disbursement',
  props: {
    disbursementInput: { type: Object, required: true }
  },
  data() {
    return {
      isSubmitting: false,
      newData: {}
    }
  },
  watch: {
    "disbursementInput.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_SATU": function (newValue) {
      const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      this.$nextTick(() => this.disbursementInput.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_SATU = result);
    },
    "disbursementInput.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_DUA": function (newValue) {
      const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      this.$nextTick(() => this.disbursementInput.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_DUA = result);
    },
    "disbursementInput.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_TIGA": function (newValue) {
      const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      this.$nextTick(() => this.disbursementInput.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_TIGA = result);
    },
    "disbursementInput.NOTIF_DISBURSE_KU_MIN": function (newValue) {
      const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      this.$nextTick(() => this.disbursementInput.NOTIF_DISBURSE_KU_MIN = result);
    },
    "disbursementInput.NOTIF_DISBURSE_KC_MIN": function (newValue) {
      const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      this.$nextTick(() => this.disbursementInput.NOTIF_DISBURSE_KC_MIN = result);
    },
    "disbursementInput.NOTIF_DISBURSE_KCS_MIN": function (newValue) {
      const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      this.$nextTick(() => this.disbursementInput.NOTIF_DISBURSE_KCS_MIN = result);
    },
    "disbursementInput.NOTIF_DISBURSE_FINANCE_MIN": function (newValue) {
      const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      this.$nextTick(() => this.disbursementInput.NOTIF_DISBURSE_FINANCE_MIN = result);
    },
    "disbursementInput.MAX_PENCAIRAN_DISBURSE_DITANGGUHKAN": function (newValue) {
      const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      this.$nextTick(() => this.disbursementInput.MAX_PENCAIRAN_DISBURSE_DITANGGUHKAN = result);
    },
  },
  methods: {
    onSubmit() {
      this.newData = JSON.parse(JSON.stringify(this.disbursementInput))
      const numberPlafondKelas1 = this.$helper.removeThousandSeparator(this.newData.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_SATU);
      this.newData.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_SATU = numberPlafondKelas1;
      const numberPlafondKelas2 = this.$helper.removeThousandSeparator(this.newData.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_DUA);
      this.newData.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_DUA = numberPlafondKelas2;
      const numberPlafondKelas3 = this.$helper.removeThousandSeparator(this.newData.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_TIGA);
      this.newData.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_TIGA = numberPlafondKelas3;
      const numberNotifDisburseKU = this.$helper.removeThousandSeparator(this.newData.NOTIF_DISBURSE_KU_MIN);
      this.newData.NOTIF_DISBURSE_KU_MIN = numberNotifDisburseKU;
      const numberNotifDisburseKC = this.$helper.removeThousandSeparator(this.newData.NOTIF_DISBURSE_KC_MIN);
      this.newData.NOTIF_DISBURSE_KC_MIN = numberNotifDisburseKC;
      const numberNotifDisburseKCS = this.$helper.removeThousandSeparator(this.newData.NOTIF_DISBURSE_KCS_MIN);
      this.newData.NOTIF_DISBURSE_KCS_MIN = numberNotifDisburseKCS;
      const numberNotifDisburseFinance = this.$helper.removeThousandSeparator(this.newData.NOTIF_DISBURSE_FINANCE_MIN);
      this.newData.NOTIF_DISBURSE_FINANCE_MIN = numberNotifDisburseFinance;
      const numberMaxPencairanDisburseDitangguhkan = this.$helper.removeThousandSeparator(this.newData.MAX_PENCAIRAN_DISBURSE_DITANGGUHKAN);
      this.newData.MAX_PENCAIRAN_DISBURSE_DITANGGUHKAN = numberMaxPencairanDisburseDitangguhkan;

      let payload = new FormData()

      for (let [key, value] of Object.entries(this.newData)) {
        payload.append("name", key)
        payload.append("value", value)
      }

      this.isSubmitting = true
      this.$axios.post("parameter/update/", payload).then(response => {
        this.$helper.toastSucc(this, "Parameter Disbursement telah berhasil diubah!")
        this.$bvModal.hide("modal-edit-disbursement")
      })
        .catch(error => {
          this.$helper.parseError(this, error)
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },

    openModalConfirm() {
      this.$bvModal.show("modal-edit-disbursement")
    },
  },
}
</script>